import React, { useState } from "react";
import PageTitle from "../shared-ui/pageTitle";
import styles from "./settings.module.scss";
import { ITab, SettingsTab, Tabs } from "../shared-ui/tabs/tabs";
import { TabPanel } from "../shared-ui/tabs/tab-panel/tab-panel";
import Invitation from "../account-invitation/invitation/invitation";
import { IAppState } from "../../redux/reducers";
import { connect } from "react-redux";
import { AccountType } from "api/entities/account";
import { EnterpriseUserTab } from "./tabs/enterprise-user-tab";
import { AccountTab } from "./tabs/account-tab/account-tab";

const mapStateToProps = (state: IAppState) => ({
    user: state.users.currentUser,
});

interface ISettingsV2Props
    extends ReturnType<typeof mapStateToProps> {
}

function SettingsV2(props: ISettingsV2Props) {
    const isEnterpriseAdmin = props.user.accountType === AccountType.Enterprise && props.user.isAdmin;

    const [tabs] = useState<ITab[]>([
        { tabType: SettingsTab.Account, isActive: true, isVisible: true },
        // { tabType: SettingsTab.EnterpriseUser, isActive: false, isVisible: isEnterpriseAdmin },
        // { tabType: SettingsTab.Invitation, isActive: false, isVisible: isEnterpriseAdmin },
    ]);
    const [activeTabType, setActiveTabType] = useState<SettingsTab>(SettingsTab.Account);
    const activeTab = activeTabType === null ? null : tabs[Number(activeTabType)];

    function activateTab(tab: ITab) {
        if (activeTab) {
            activeTab.isActive = false;
        }
        const activeIndex = tabs.indexOf(tab);
        tab.isActive = true;
        setActiveTabType(activeIndex);
    }

    function getTab() {
        let tab = <></>;

        switch (activeTabType) {
            case SettingsTab.Account:
                tab = <AccountTab activeTab={activeTabType} />;
                break;
            // case SettingsTab.EnterpriseUser:
            //     tab = <EnterpriseUserTab activeTab={activeTabType} />;
            //     break;
            // case SettingsTab.Invitation:
            //     tab = <Invitation />;
            //     break;
        }

        return tab;
    }

    return (
        <>
            <PageTitle title="Settings"/>
            <div className={styles["page-content"]}>
                <Tabs tabs={tabs} onActivate={activateTab}/>

                {activeTab &&
                    <TabPanel tab={activeTab} className={styles["tab-panel"]}>
                        {getTab()}
                    </TabPanel>
                }
            </div>
        </>
    );
}

export default connect(mapStateToProps, null)(SettingsV2);
